import React, { useState } from "react";
import { Modal, Button, Image } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

import "../../styles/Managers/managerList.scss";

interface componentProps {
  modalShow: boolean;
  handleModal: (val: boolean, confirm: string) => void;
}

const DeletePopup: React.FC<componentProps> = ({ modalShow, handleModal }) => {
  const location = useLocation();
  let path = location.pathname.split("/");

  const isSync = path[1] === "settings";

  const handleLogout = () => {
    document.cookie =
      "X-XSRF-TOKEN = null;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    localStorage.clear();
    window.location.href = "/";
  };


  return (
    <Modal
      show={modalShow}
      size="lg"
      onHide={() => handleModal(false, "No")}
      centered
      className={`del-alert ${isSync ? 'sync-modal' : ''}`}
    >
      <Modal.Body>
        <div className="modal-container">
          <div className="d-flex flex-column align-items-center">
            {!isSync && (
              <>
                <div className="cls-icon">
                  <Image src="/images/roles/danger_delete.svg" />
                </div>
                <div className="modal-head">
                  {path[1] !== "roles" ? (
                    <h5>Delete Manager</h5>
                  ) : (
                    <h5>Delete Role</h5>
                  )}
                </div>
              </>
            )
            }

            <div className="modal-desc">
              {isSync ? (
                <p>Would you like to log out to see updated details?</p>
              ) : path[1] !== "roles" ? (
                <p>Are you sure you want to delete this Manager?</p>
              ) : (
                <p>Are you sure you want to delete this role?</p>
              )}
            </div>

            <div className="choose-btns d-flex flex-row">
              <div>
                <Button
                  variant="outline-dark"
                  className="cancel-btn"
                  onClick={() => handleModal(false, "No")}
                >
                  {isSync ? "Not now" : "Cancel"}
                </Button>
              </div>
              <div className="ms-3">
                <Button
                  className="remove-btn"
                  onClick={() => {
                    if (isSync) {
                      handleLogout();
                    } else {
                      handleModal(false, "Yes");
                    }
                  }}
                >
                  {isSync ? "Logout" : "Delete"}
                </Button>
              </div>
            </div>
          </div>

          {!isSync &&
            <div
              className="close-btn cursor-pointer"
              onClick={() => handleModal(false, "No")}
            >
              <Image src="/images/roles/modal_close_icon.svg" alt="Close" />
            </div>
          }
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeletePopup;
